export default "__VITE_ASSET__BLLaQ09D__"